import { useState } from 'react';
import { TextField } from '@mui/material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { makeStyles } from '@mui/styles';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const useStyles = makeStyles(theme => ({
    root: {
        '& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
            color: 'black'
        }
    },
    chip: {
        display: 'none'
    }
}));

export function FilterByUser({ cardholders, selectedUsers, setSelectedUsers, setPagination }) {
    const classes = useStyles();
    const [shrink, setShrink] = useState(false);

    const handleSearchChange = async (event, newValue) => {
        setSelectedUsers(newValue);
        setPagination({
            page: 0,
            rowsPerPage: 10
        });
    };

    const filterOptions = createFilterOptions({
        matchFrom: 'any',
        stringify: option => `${option.first_name} ${option.last_name} ${option.email} `
    });
    const handleFocus = async () => {
        setShrink(true);
    };
    const handleBlur = async () => {
        setShrink(false);
    };

    return (
        <Autocomplete
            renderInput={params =>
                selectedUsers.length === 0 ? (
                    <TextField {...params} InputLabelProps={{ shrink: shrink }} label="All Users" />
                ) : selectedUsers.length === 1 ? (
                    <TextField {...params} InputLabelProps={{ shrink: shrink }} label="1 User" />
                ) : (
                    <TextField {...params} InputLabelProps={{ shrink: shrink }} label={`${selectedUsers.length} Users`} />
                )
            }
            classes={classes}
            options={cardholders}
            getOptionLabel={option => `${option.first_name} ${option.last_name}`}
            clearOnEscape={true}
            onFocus={handleFocus}
            onBlur={handleBlur}
            filterOptions={filterOptions}
            renderOption={(props, option, { selected }) => (
                <li {...props} key={option.id}>
                    <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
                    <li style={{ width: 380, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                        <span style={{ color: '#122d55', fontSize: 15, fontWeight: 500 }}>
                            {option.first_name} {option.last_name}
                        </span>
                        <br />
                        <span
                            style={{
                                color: 'gray',
                                fontSize: 13,
                                fontWeight: 300,
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis'
                            }}>
                            {option.email}
                        </span>
                    </li>
                </li>
            )}
            onChange={handleSearchChange}
            multiple
            disableCloseOnSelect
            size="small"
            ChipProps={{ className: classes.chip, disabled: 'true', size: 'small', deleteIcon: 'none' }}
            id="search-user-autocomplete"
            sx={{ width: '100%' }}
            className="transactions-search__item"
        />
    );
}
